<template>
  <div id="container-ms-DocumentacaoInterativaChat-9775" v-show="shouldShowChatbot"></div>
</template>

<script>
import chatHelpManager from '@/services/chat-help.manager'

export default {
  name: 'ChatbotHelp',
  data () {
    return {
      shouldShowChatbot: false
    }
  },
  methods: {
    showChatHelp (show) {
      this.shouldShowChatbot = show
    }
  },
  mounted () {
    chatHelpManager.handleChatHelp = this.showChatHelp
    const script = document.createElement('script')
    script.src = 'https://omnichannel-sdk.mosiaomnichannel.com.br/'
    script.onload = () => {
      window.omnichannelSDK.embed({
        id: 'container-ms-DocumentacaoInterativaChat-9775',
        url: 'https://chat.mosiaomnichannel.com.br',
        json: {
          configuration: {
            flutuante: true,
            idFuncionalidade: '9775',
            instanciaAplicacao: 1,
            bundle:
              'MTAwLjExNi40OC4xMDEuMTEzLjExMS40OC4xMTEuMTEzLjEwMC4xMDcuMTEwLjEwMy4xMTcuOTkuMTE5LjEwMi4xMDMuNDguMTAxLjExMy4xMTEuMTAzLjExNi4xMDEuMTA3Ljk5LjExMC4xMTcuOTkuMTE5LjEwMi4xMDMu',
            authorization: null,
            esquemaCor: null
          },
          floatStyle: {
            height: '650px',
            width: '500px',
            bottom: '60px'
          }
        }
      })
    }
    document.head.appendChild(script)
  }
}
</script>
